import _items from "./items";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const items_1 = _items;
const def = {
  keyword: "prefixItems",
  type: "array",
  schemaType: ["array"],
  before: "uniqueItems",
  code: cxt => (0, items_1.validateTuple)(cxt, "items")
};
exports.default = def;
//# sourceMappingURL=prefixItems.js.map
export default exports;